export default "__VITE_ASSET__DIWYBi4H__"